import { FC, useState } from 'react';
import { HTHAssignmentsByTerritory } from './HTHAssignmentsByTerritory';
import { HTHAssignmentsByUser } from './HTHAssignmentsByUser';
import { RadioSelector } from 'src/components/_commons';
import { typeHTHTerritory, typeUser } from '@monorepo/models';

type propsType = {
    hthTerritories: typeHTHTerritory[];
    users: typeUser[] | null;
};

export const HTHAssignments: FC<propsType> = ({ hthTerritories, users }) => {
    const [radioValue, setRadioValue] = useState<'1' | '2'>('1');

    return (
        <div className={'mt-5'}>
            <RadioSelector
                options={[
                    { label: radioValue === '1' ? 'Viendo por Territorio' : 'Ver por Territorio', type: '1' },
                    { label: radioValue === '2' ? 'Viendo por Usuario' : 'Ver por Usuario', type: '2' }
                ]}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === '1' ?
                hthTerritories.sort((t1, t2) => parseInt(t1.territoryNumber) - parseInt(t2.territoryNumber)).map(t =>
                    <HTHAssignmentsByTerritory key={t.territoryNumber}
                        t={t}
                        users={users}
                    />
                )
                :
                <HTHAssignmentsByUser
                    users={users}
                />
            }
        </div>
    );
}
